import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';

import { NbAuthService } from '@nebular/auth';
import { RuoliUtente } from '@hm_app/@core/models/utente';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';

import * as _ from 'lodash-es';
import { NbRoleProvider } from '@nebular/security';

export function userRole(roles: string | string[]): boolean {
    return userRoles(roles).length > 0;
}

export function userRoles(roles: string | string[]): string[] {
    if (!roles) {
        return [];
    }

    if (!_.isArray(roles)) {
        roles = [roles as string];
    }

    return _.intersection([
        RuoliUtente.user,
        RuoliUtente.user_arpa,
    ], roles);
}

@Injectable()
export class UsersAuthGuard implements CanActivate, CanActivateChild {

    constructor(
        private authService: NbAuthService,
        private roleProvider: NbRoleProvider,
        private router: Router,
    ) { }

    async canActivate() {
        if (!this.authService.isAuthenticated()) {
            return false;
        }

        const roles = await this.roleProvider.getRole().toPromise();
        if (userRole(roles)) {
            return true;
        }

        this.router.navigate(['/public']);
        return false;

		/*
		if (this.authService.isAuthenticated() && this.authService.get)
		  return true;
		else
		  this.router.navigate(['/auth/public']);

		this.authService.isAuthenticated
		const user = this.hmService.auth_user;
		const role = user ? user.role : null;

		if (this.isAuthorized(role)) {
		  return true;
		}

		this.router.navigate(['/public']);
		*/
    }

    async canActivateChild() {
        return this.canActivate();
    }

}
